import { useEffect, useRef } from "react"
import { useReadChatHistory } from "@/modules/chats/hooks/useChatHistory"
import { useGreetingPrefill } from "@/modules/chats/hooks/useGreetingPrefill"
import { ChatThread } from "@/modules/chats/types/chat-thread"

export const useAutoTranslationGreetingRebuilder = (selectedThread: ChatThread): void => {
  const applyGreeting = useGreetingPrefill()
  const readHistory = useReadChatHistory()

  const isLiveTranslationEnabled = selectedThread.autoTranslationSetting?.isLiveTranslationEnabled ?? false
  const targetAgentLanguage = selectedThread.autoTranslationSetting?.targetAgentLanguage
  const previous = useRef({ isLiveTranslationEnabled, targetAgentLanguage })

  useEffect(() => {
    const wasLiveTranslationEnabled = previous.current.isLiveTranslationEnabled
    const previousAgentLanguage = previous.current.targetAgentLanguage
    previous.current = { isLiveTranslationEnabled, targetAgentLanguage }

    const wasActivated = !wasLiveTranslationEnabled && isLiveTranslationEnabled
    const wasDeactivated = wasLiveTranslationEnabled && !isLiveTranslationEnabled
    const agentLanguageChanged =
      isLiveTranslationEnabled && wasLiveTranslationEnabled && previousAgentLanguage !== targetAgentLanguage
    if (!wasActivated && !wasDeactivated && !agentLanguageChanged) return

    const isGreetingStillPending = readHistory().some((message) => message.aiFeatures.includes("GREETING"))
    if (!isGreetingStillPending) return

    applyGreeting(selectedThread)
  }, [isLiveTranslationEnabled, targetAgentLanguage, selectedThread, applyGreeting, readHistory])
}
